module.exports = __webpack_public_path__ + "img/team.ce366832.svg";